module.exports = __webpack_public_path__ + "img/CCS1.74967b67.svg";